import { compose, lifecycle, withState } from "recompose";

export const withPaymentRequest = compose(
  withState("canMakePaymentWithButton", "setCanMakePaymentWithButton", false)
);
